import { icon } from "../functions/icons";

export function SidebarToggle({ toggleSidebar }) {
    return (
        <div className="sidebar-icon standard-border standard-rounded small-icon"  onClick={toggleSidebar}>{icon('menu')}</div>
    )
  }